import React, { Component } from 'react';
import './footer.css';

class footer extends Component {
    render() {
        return (
            <div id="footerParent">
                <ul className="footer">
                    <li>Designed and developed by Spencer Scher.</li>
                </ul>
            </div>
        );
    }
}

export default footer;